/* eslint-disable max-len */
import css from 'styled-jsx/css'
import { colors } from '../../styles'
import hero from './images/HeroImage.jpg'

const {
  white,
} = colors

export default css`
.out-of-region{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 581px;
    top: 0%;
    background: url(${hero});
    background-size: cover;
    background-position: bottom;
}
.rainbow-text{
    color: ${white};
    font-weight: 600;
    font-size: 48px;
    background: #D472E0;
    background: -webkit-linear-gradient(to right, #D472E0 0%, #F915A2 33%, #E5BF00 67%, #14CC7D 100%);
    background: -moz-linear-gradient(to right, #D472E0 0%, #F915A2 33%, #E5BF00 67%, #14CC7D 100%);
    background: linear-gradient(to right, #D472E0 0%, #F915A2 33%, #E5BF00 67%, #14CC7D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-top: 1em;
    padding-bottom: 0.75em;

}


.p{
    max-width: 577.36px;
    font-weight: 400;
    font-size: 22px;
    line-height: 27.65px;
    text-align: center;
    color: ${white};
    padding-bottom: 36px;
}`
